import { render, staticRenderFns } from "./painter4.vue?vue&type=template&id=882ca64a&scoped=true&"
import script from "./painter4.vue?vue&type=script&lang=js&"
export * from "./painter4.vue?vue&type=script&lang=js&"
import style0 from "./painter4.vue?vue&type=style&index=0&id=882ca64a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882ca64a",
  null
  
)

export default component.exports